import React from "react";
import { Star } from "lucide-react";

/**
 * Compact star rating display.
 *  - readOnly mode shows half-filled stars based on `rating`.
 *  - Interactive mode (onChange provided) renders 5 buttons that set the rating.
 */
export default function StarRating({
  rating = 0,
  size = 14,
  onChange,
  testid,
  className = "",
  showNumber = false,
  count,
}) {
  const interactive = typeof onChange === "function";
  const stars = [1, 2, 3, 4, 5];

  return (
    <div className={`inline-flex items-center gap-1 ${className}`} data-testid={testid}>
      <div className="flex items-center">
        {stars.map((n) => {
          const filled = rating >= n - 0.25;
          const half = !filled && rating >= n - 0.75;
          if (interactive) {
            return (
              <button
                key={n}
                type="button"
                onClick={() => onChange(n)}
                className="p-0.5 hover:scale-110 transition"
                data-testid={testid ? `${testid}-star-${n}` : undefined}
                aria-label={`${n} star${n > 1 ? "s" : ""}`}
              >
                <Star
                  size={size}
                  className={filled ? "fill-[#FFA62B] text-[#FFA62B]" : "text-zinc-300"}
                />
              </button>
            );
          }
          return (
            <span key={n} className="relative inline-flex" aria-hidden="true">
              <Star size={size} className="text-zinc-200" />
              {(filled || half) && (
                <span
                  className="absolute inset-0 overflow-hidden"
                  style={{ width: filled ? "100%" : "50%" }}
                >
                  <Star size={size} className="fill-[#FFA62B] text-[#FFA62B]" />
                </span>
              )}
            </span>
          );
        })}
      </div>
      {showNumber && (
        <span className="text-xs font-semibold text-zinc-600">
          {rating ? rating.toFixed(1) : "—"}
          {typeof count === "number" && (
            <span className="text-zinc-400 font-normal"> · {count}</span>
          )}
        </span>
      )}
    </div>
  );
}
